import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateUser($customerId: ID!, $defaultWorkspaceId: ID) {
    updateUser(customerId: $customerId, defaultWorkspaceId: $defaultWorkspaceId) {
      id
    }
  }
`;

export const updateUser = (customerId, defaultWorkspaceId) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, defaultWorkspaceId },
  }).then(({ data }) => getSingleProp(data));
